import useEmblaCarousel from 'embla-carousel-react';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { api_getPersonalizedProductsIdsByCategoryId, api_getProductsByIds } from '~/backend/api_calls';
import PersonalisedProducts from '~/backend/personalised_products';
import { sendViewItemListGTMEvent } from '~/common/gtm';
import ProductBox from './ProductBox';

const ProductsPersonalised = ({ title, excludedProductId, categoryId }) => {
	const [products, setProducts] = useState([]);

	let productsIds = PersonalisedProducts.getItems();
	if (excludedProductId !== undefined) productsIds = productsIds.filter(value => value != excludedProductId);

	useEffect(() => {
		if (productsIds.length > 0) {
			api_getProductsByIds(productsIds.toString())
				.then(json => {
					setProducts(json.items);
					sendViewItemListGTMEvent(json.items, 0, title);
				})
				.catch(error => console.error(error));
		} else if (categoryId !== undefined) {
			api_getPersonalizedProductsIdsByCategoryId(categoryId)
				.then(json => {
					const productsIds = json.items?.map(x => x.id)?.join(',');
					api_getProductsByIds(productsIds.toString())
						.then(json => {
							setProducts(json.items);
							sendViewItemListGTMEvent(json.items, 0, title);
							PersonalisedProducts.add(json.items);
						})
						.catch(error => console.error(error));
				})
				.catch(error => console.error(error));
		}
	}, []);

	const [emblaRefPersonalised, emblaApiPersonalised] = useEmblaCarousel({ loop: false, slidesToScroll: 4 });

	const scrollPrev = useCallback(() => {
		if (emblaApiPersonalised) emblaApiPersonalised.scrollPrev();
	}, [emblaApiPersonalised]);

	const scrollNext = useCallback(() => {
		if (emblaApiPersonalised) emblaApiPersonalised.scrollNext();
	}, [emblaApiPersonalised]);

	if (products.length === 0) return null;

	return (
		<div id="personalised-products">
			<div className="content-wrapper">
				<h3>{title}</h3>
				<div className="embla_pers" ref={emblaRefPersonalised}>
					<div className="embla__container">
						{products.map((item, index) => (
							<div className="embla__slide" key={index}>
								<ProductBox idx={index} key={index} product={item} listName={title} />
							</div>
						))}
					</div>
					{/* }<a href={product_link(item.eurl)} className="product-box" >
                <img src={convertImageUrl_S_to_M(item.img1)} />
                <h3 className="tab-title">{item.nm}</h3>
                <div className="product-price"></div>
            </a>*/}
					<div className="embla_controls desktop641">
						<button className="embla_control embla__prev white-back" onClick={scrollPrev} title="Previous">
							<svg xmlns="http://www.w3.org/2000/svg" width="7.095" height="12.69" viewBox="0 0 7.095 12.69">
								<path
									id="Path_38025"
									data-name="Path 38025"
									d="M18,7.5l5.815,5.815L18,19.129"
									transform="translate(-17.47 -6.97)"
									fill="none"
									stroke="#000"
									strokeLinejoin="round"
									strokeWidth="1.5"
								/>
							</svg>
						</button>

						<button className="embla_control embla__next white-back" onClick={scrollNext} title="Next">
							<svg xmlns="http://www.w3.org/2000/svg" width="7.095" height="12.69" viewBox="0 0 7.095 12.69">
								<path
									id="Path_38025"
									data-name="Path 38025"
									d="M18,7.5l5.815,5.815L18,19.129"
									transform="translate(-17.47 -6.97)"
									fill="none"
									stroke="#000"
									strokeLinejoin="round"
									strokeWidth="1.5"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

ProductsPersonalised.propTypes = {
	title: PropTypes.string,
	excludedProductId: PropTypes.number,
	categoryId: PropTypes.number
};

export default ProductsPersonalised;
